const PROD = {
  apiBaseUrl: process.env.REACT_APP_BASE_URL || 'https://api.sayma.sba.sa/',
  reCaptchaPublicKey: process.env.REACT_APP_RECAPTCHA_CLIENT_SITE_KEY || 'noKey',
  totalCountHeader: process.env.REACT_APP_PAGINATION_COUNT_HEADER_NAME,
  superAdminId: process.env.REACT_APP_SUPER_ADMIN_ID,
  marketplaceBaseUrl: process.env.REACT_APP_MARKETPLACE_BASE_URL,
};

const STAGING = {
  apiBaseUrl: process.env.REACT_APP_BASE_URL || 'https://apistg.sayma.sba.sa/',
  reCaptchaPublicKey: process.env.REACT_APP_RECAPTCHA_CLIENT_SITE_KEY || 'noKey',
  totalCountHeader: process.env.REACT_APP_PAGINATION_COUNT_HEADER_NAME,
  superAdminId: process.env.REACT_APP_SUPER_ADMIN_ID,
  marketplaceBaseUrl: process.env.REACT_APP_MARKETPLACE_BASE_URL,
};

const DEV = {
  apiBaseUrl: process.env.REACT_APP_BASE_URL || STAGING.apiBaseUrl,
  reCaptchaPublicKey: process.env.REACT_APP_RECAPTCHA_CLIENT_SITE_KEY || 'noKey',
  totalCountHeader: process.env.REACT_APP_PAGINATION_COUNT_HEADER_NAME,
  superAdminId: process.env.REACT_APP_SUPER_ADMIN_ID,
  marketplaceBaseUrl: process.env.REACT_APP_MARKETPLACE_BASE_URL,
};

const config = process.env.REACT_APP_ENV === 'production' ? PROD : process.env.REACT_APP_ENV === 'staging' ? STAGING : DEV;

export default config;
